import { API_PREFIX } from '../config/appConfig';
import ApiService from './api.service';
import { UserRegistrationData } from '../types/models/User';
import { AuthResponse } from '../types/models/AuthResponse';

const AuthService = {

  sendRegistrationOtp: async (phone) => {
    const response = await fetch(`${API_PREFIX}/send-registration-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phone })
    });
    return response.json();
  },

  completeRegistration: async (userData) => {
    const mappedData = new UserRegistrationData({
      first_name: userData.nome,
      last_name: userData.cognome,
      email: userData.email,
      password: userData.password,
      phone: userData.phone || '',
      gender: userData.gender || 'OTHER',
      tag_id: userData.tag_id || null,
      otp: userData.otp,
      city: userData.city || ''
    });

    console.log('AuthService - completeRegistration - dati mappati:', mappedData);

    const response = await fetch(`${API_PREFIX}/complete-registration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(mappedData)
    });

    return response.json();
  },
  checkDuplicates: async (email, phone) => {
    const response = await fetch(`${API_PREFIX}/check-duplicates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, phone })
    });
    return await response.json();
  },

  // Registrazione utente con verifica OTP
  register: async (userData) => {
    console.log('%c [DEBUG] AuthService - register ENTER', 'background: #222; color: #bada55', {
      userData
    });

    try {
      const mappedData = new UserRegistrationData({
        first_name: userData.nome,
        last_name: userData.cognome,
        email: userData.email,
        password: userData.password,
        phone: userData.phone || '',
        gender: userData.gender || 'OTHER',
        tag_id: userData.tag_id || null
      });

      const response = await fetch(`${API_PREFIX}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(mappedData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || Object.values(data.errors)[0][0]);
      }

      console.log('%c [DEBUG] AuthService - register SUCCESS', 'background: #222; color: #01FF70', {
        response: data
      });

      // Salviamo il token solo se la registrazione non richiede verifica OTP
      if (data.token && !data.requires_verification) {
        localStorage.setItem('auth_token', data.token);
      }

      return data;
    } catch (error) {
      console.error('%c [DEBUG] AuthService - register ERROR', 'background: #222; color: #FF4136', {
        error: error.message
      });
      throw error;
    }
  },

  // Verifica OTP
  verifyOtp: async (phone, otp) => {
    console.log('%c [DEBUG] AuthService - verifyOtp ENTER', 'background: #222; color: #bada55', {
      phone,
      otp
    });

    try {
      const response = await fetch(`${API_PREFIX}/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ phone, otp })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Errore nella verifica OTP');
      }

      console.log('%c [DEBUG] AuthService - verifyOtp SUCCESS', 'background: #222; color: #01FF70', {
        response: data
      });

      // Se la verifica è riuscita e riceviamo un token, lo salviamo
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
      }

      return data;
    } catch (error) {
      console.error('%c [DEBUG] AuthService - verifyOtp ERROR', 'background: #222; color: #FF4136', {
        error: error.message
      });
      throw error;
    }
  },

  // Login utente
  login: async (credentials) => {
    try {
      const response = await fetch(`${API_PREFIX}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Errore durante il login');
      }

      const authResponse = new AuthResponse(data);

      localStorage.setItem('auth_token', authResponse.token);
      localStorage.setItem('has_survey', authResponse.has_survey?.toString() || 'false');
      localStorage.setItem('user', JSON.stringify(authResponse.user));

      console.log('%c [DEBUG] AuthService - login SUCCESS', 'background: #222; color: #01FF70', {
        response: authResponse
      });

      return authResponse;
    } catch (error) {
      console.error('%c [DEBUG] AuthService - login ERROR', 'background: #222; color: #FF4136', {
        error: error.message
      });
      throw error;
    }
  },

  // Logout utente
  logout: async () => {
    console.log('[DEBUG] AuthService - logout ENTER');
    try {
      await ApiService.fetch('logout', {
        method: 'POST'
      });
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      localStorage.removeItem('has_survey');
    } catch (error) {
      console.error('[DEBUG] AuthService - logout error:', error);
      throw error;
    }
  },

  // Verifica autenticazione
  isAuthenticated: () => {
    const hasToken = !!localStorage.getItem('auth_token');
    console.log('[DEBUG] AuthService - isAuthenticated:', hasToken);
    return hasToken;
  },

  // Recupero token
  getToken: () => {
    const token = localStorage.getItem('auth_token');
    console.log('[DEBUG] AuthService - getToken:', token ? 'Token exists' : 'No token');
    return token;
  },

  // Recupero ID utente corrente
  getCurrentUserId: () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.id;
  },

  // Aggiungi questo metodo al tuo AuthService
  getUserFromStorage: () => {
    try {
      const userString = localStorage.getItem('user');
      if (!userString) {
        return null;
      }
      return JSON.parse(userString);
    } catch (error) {
      console.error('[DEBUG] AuthService - getUserFromStorage ERROR:', error);
      return null;
    }
  },
};

export default AuthService;